import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.is-array";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license
 * Copyright 2018 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { ENGINE } from '../engine';
import { dispose as _dispose, tidy } from '../globals';
import { fill } from '../ops/fill';
import { registerClass } from '../serialization';
import { Optimizer } from './optimizer';
/** @doclink Optimizer */

export var AdagradOptimizer = /*#__PURE__*/function (_Optimizer) {
  _inherits(AdagradOptimizer, _Optimizer);

  var _super = _createSuper(AdagradOptimizer);

  function AdagradOptimizer(learningRate) {
    var _this;

    var initialAccumulatorValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.1;

    _classCallCheck(this, AdagradOptimizer);

    _this = _super.call(this);
    _this.learningRate = learningRate;
    _this.initialAccumulatorValue = initialAccumulatorValue;
    _this.accumulatedGrads = [];
    return _this;
  }

  _createClass(AdagradOptimizer, [{
    key: "applyGradients",
    value: function applyGradients(variableGradients) {
      var _this2 = this;

      var variableNames = Array.isArray(variableGradients) ? variableGradients.map(function (item) {
        return item.name;
      }) : Object.keys(variableGradients);
      variableNames.forEach(function (name, i) {
        var value = ENGINE.registeredVariables[name];

        if (_this2.accumulatedGrads[i] == null) {
          var trainable = false;
          _this2.accumulatedGrads[i] = {
            originalName: "".concat(name, "/accumulator"),
            variable: tidy(function () {
              return fill(value.shape, _this2.initialAccumulatorValue).variable(trainable);
            })
          };
        }

        var gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];

        if (gradient == null) {
          return;
        }

        var accumulatedGrad = _this2.accumulatedGrads[i].variable;
        tidy(function () {
          var newAccumulatedGrad = accumulatedGrad.add(gradient.square());
          accumulatedGrad.assign(newAccumulatedGrad);
          var newValue = gradient.div(newAccumulatedGrad.add(ENGINE.backend.epsilon()).sqrt()).mul(-_this2.learningRate).add(value);
          value.assign(newValue);
        });
      });
      this.incrementIterations();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.accumulatedGrads != null) {
        _dispose(this.accumulatedGrads.map(function (v) {
          return v.variable;
        }));
      }
    }
  }, {
    key: "getWeights",
    value: function () {
      var _getWeights = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.saveIterations();

              case 2:
                _context.t0 = _context.sent;
                return _context.abrupt("return", [_context.t0].concat(this.accumulatedGrads.map(function (v) {
                  return {
                    name: v.originalName,
                    tensor: v.variable
                  };
                })));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getWeights() {
        return _getWeights.apply(this, arguments);
      }

      return getWeights;
    }()
  }, {
    key: "setWeights",
    value: function () {
      var _setWeights = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(weightValues) {
        var trainable;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.extractIterations(weightValues);

              case 2:
                weightValues = _context2.sent;
                trainable = false;
                this.accumulatedGrads = weightValues.map(function (v) {
                  return {
                    originalName: v.name,
                    variable: v.tensor.variable(trainable)
                  };
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setWeights(_x) {
        return _setWeights.apply(this, arguments);
      }

      return setWeights;
    }()
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        'learningRate': this.learningRate,
        'initialAccumulatorValue': this.initialAccumulatorValue
      };
    }
    /** @nocollapse */

  }], [{
    key: "fromConfig",
    value: function fromConfig(cls, config) {
      return new cls(config['learningRate'], config['initialAccumulatorValue']);
    }
  }]);

  return AdagradOptimizer;
}(Optimizer);
/** @nocollapse */

AdagradOptimizer.className = 'Adagrad'; // Note: Name matters for Python compatibility.

registerClass(AdagradOptimizer);